
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandM as ObiOwnShipNoCommandMElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-m.js';
 
 
 

 
 export const ObiOwnShipNoCommandM = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-m',
   elementClass: ObiOwnShipNoCommandMElement,
   events: {
     
   }
  });
 
 